import Close from "@mui/icons-material/Close";
import LightbulbOutlined from "@mui/icons-material/LightbulbOutlined";
import { Box, Button, DialogContent, IconButton, Stack, Typography } from "@mui/material";
import { SafeDialog } from "components/Dialog";
import ScoutIcon from "components/ScoutIcon";

import { encampBrandColors } from "../../../../colors";
import sourcesIcon from "../ScoutInfoPanel/assets/sources.png";
import { SCOUT_LAUNCH_MODAL_COPY } from "./scoutLaunchAnnouncementConfig";

type ScoutLaunchAnnouncementModalProps = {
  open: boolean;
  onDismiss: () => void;
  onLearnMore: () => void;
  onStartTour: () => void;
};

export function ScoutLaunchAnnouncementModal({
  open,
  onDismiss,
  onLearnMore,
  onStartTour,
}: ScoutLaunchAnnouncementModalProps) {
  return (
    <SafeDialog
      open={open}
      onClose={onDismiss}
      maxWidth="sm"
      aria-labelledby="scout-launch-announcement-title"
      slotProps={{
        backdrop: { sx: { bgcolor: "rgba(4, 17, 32, 0.55)" } },
        paper: {
          sx: {
            borderRadius: 1,
            px: { xs: 3, sm: 5 },
            py: { xs: 3, sm: 5 },
            maxWidth: 540,
          },
        },
      }}
    >
      <IconButton
        aria-label="Dismiss Scout launch announcement"
        onClick={onDismiss}
        sx={{ position: "absolute", top: 12, right: 12 }}
      >
        <Close />
      </IconButton>

      <DialogContent sx={{ p: 0, overflow: "visible" }}>
        <Stack spacing={{ xs: 3, sm: 5 }} alignItems="center" textAlign="center">
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: "50%",
              bgcolor: encampBrandColors.pumpkin,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ScoutIcon sx={{ fontSize: 56, color: "common.white" }} />
          </Box>

          <Stack spacing={0.75}>
            <Typography id="scout-launch-announcement-title" variant="h5" fontWeight={400}>
              {SCOUT_LAUNCH_MODAL_COPY.headline}
            </Typography>
            <Typography variant="h6" color="text.secondary" fontWeight={500}>
              {SCOUT_LAUNCH_MODAL_COPY.subheadline}
            </Typography>
          </Stack>

          <Stack direction="row" spacing={2} alignItems="flex-start" textAlign="left" width="100%">
            <Box sx={{ position: "relative", flexShrink: 0, mt: 0.25 }}>
              <img src={sourcesIcon} alt="Sources" style={{ width: 56, height: 56 }} />
            </Box>
            <Typography variant="body1" color="text.primary">
              Scout is grounded in the <strong>CFR</strong> and{" "}
              <strong>Encamp&apos;s compliance knowledge base</strong> and can answer the regulatory
              questions you run into every day.
            </Typography>
          </Stack>

          <Button
            variant="text"
            color="primary"
            startIcon={<LightbulbOutlined />}
            onClick={onLearnMore}
            sx={{ alignSelf: "center", textTransform: "none", fontWeight: 400 }}
          >
            {SCOUT_LAUNCH_MODAL_COPY.learnMoreLabel}
          </Button>
          <Button
            variant="contained"
            color="sapphire"
            onClick={onStartTour}
            sx={{ textTransform: "none", fontWeight: 400, fontSize: 16 }}
          >
            {SCOUT_LAUNCH_MODAL_COPY.startTourLabel}
          </Button>
        </Stack>
      </DialogContent>
    </SafeDialog>
  );
}
